import React from 'react'
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import 'moment/locale/pt-br'
import 'react-datepicker/dist/react-datepicker.css';
import $ from 'jquery';
import cadastrarItinerario from '../../actions/itinerario/cadastrarItinerario'
import alterarItinerario from '../../actions/itinerario/alterarItinerario'
import {renderFieldSelect, requiredSelect} from '../../util/inputs';
import alterarVeiculoItinerario from '../../actions/itinerario/alterarVeiculoItinerario';
import {showSuccessMsg} from '../../util/messagesUtil';
import { ativarItinerario, inativarItinerario } from '../../actions/itinerario/ativarOuInativarItinerario';
import { BotaoAtivarOuInativar } from './BotaoAtivarOuInativar';

const ANDARES = [{
  label: '1º Andar',
  value: 1
}, {
  label: '2º Andar',
  value: 2
}]

export class ModalAlterarVeiculoItinerario extends React.Component {
  constructor (props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.limparFormulario = this.limparFormulario.bind(this);
    this.buscarItinerarios = this.buscarItinerarios.bind(this);
    this.fecharModal = this.fecharModal.bind(this);
  }

  buscarItinerarios () {    
    this.props.buscarItinerarios();
  }

  montarParametroItinerario (values) {
    return {
      id: this.props.itinerarioSelecionado.id,
      idVeiculo: values.veiculo.value.id,
      idEmpresa: this.props.empresaSelecionada.id,
      andar: values.veiculo.value.seDoisAndares ? values.andar.value : 1
    }
  }

  fecharModal () {
    $('#modalAlterarVeiculoItinerario')
      .modal('hide');
    $('#modalAlterarVeiculoItinerario')
      .hide();
    $('.modal-backdrop')
      .hide();
    this.limparFormulario();
  }

  submit (values) {    
    const parametros = this.montarParametroItinerario(values)
    this.props.alterarVeiculoItinerario(parametros)
      .then(() => {
          showSuccessMsg('Itinerário alterado com sucesso');
          this.fecharModal();
          this.buscarItinerarios()
      })
  }


  limparFormulario () {
    this.props.reset('formularioAlterarVeiculoItinerario');
  }

  exibirComboVeiculo () {
    return <Field name='veiculo'
           options={this.props.veiculos.map(elemento => ({
             descricao: elemento.descricao,
             nome: elemento
           }))}
           component={renderFieldSelect}
           label="Veículo"
           menuPortalTarget={document.body}
           placeholder='Selecione o veículo' validate={requiredSelect}/>
  }

  render () {
    const {
      handleSubmit, submitting, invalid, pristine
    } = this.props;
    return (
      <div className="modal fade show" id='modalAlterarVeiculoItinerario' role='dialog'
           aria-labelledby='modalAlterarVeiculoItinerario' aria-hidden='true' data-backdrop='static'>
        <div className={'modal-dialog modal-dialog-centered modal-xl'}>
          <div className="modal-content vx-modal-content">
            <div className="vx-modal-header">
              <div className="vx-modal-header-left">
                <i className="material-icons">directions_bus</i>
                <span className="vx-modal-title">Alterar Veículo</span>
              </div>
              <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Close"
                      onClick={this.limparFormulario}>
                <i className="material-icons">close</i>
              </button>
            </div>
            <div className="vx-modal-body">
              <form id="form-alterar-veiculo-itinerario" onSubmit={handleSubmit(this.submit)}>
                <div className="form-row">
                  <div className="col-12 col-sm-9 col-md-9">
                    <div className="form-row mt-2">
                      <div className="col-12 col-sm-9 col-md-9">
                        {this.exibirComboVeiculo()}
                      </div>
                    </div>
                    <div className="form-row mt-2">
                      <div className="col-12 col-sm-9 col-md-9">
                        {this.exibirComboAndar()}
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="vx-modal-footer">
              {this.props.itinerarioSelecionado.id && <BotaoAtivarOuInativar
                                            idItinerario={this.props.itinerarioSelecionado.id}
                                            idEmpresa={this.props.itinerarioSelecionado.idEmpresa}
                                            ativo={this.props.itinerarioSelecionado.ativo}
                                            ativarItinerario={this.props.ativarItinerario}
                                            inativarItinerario={this.props.inativarItinerario}
                                            buscarItinerarios={this.buscarItinerarios}
                                            fecharModal={this.fecharModal} />}
              <button type="submit" form="form-alterar-veiculo-itinerario"
                      disabled={invalid || submitting || pristine}
                      className="vx-btn-primary">
                <i className="material-icons" style={{ fontSize: '16px' }}>save</i> Salvar
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }


  exibirComboAndar () {
    if (this.props.veiculo && this.props.veiculo.value.seDoisAndares) {
      return <div>
        <Field name='andar'
               options={ANDARES.map(elemento => ({
                 descricao: elemento.label,
                 nome: elemento.value
               }))}
               component={renderFieldSelect}
               label='Andar'
               menuPortalTarget={document.body}
               placeholder='Selecione o andar' validate={requiredSelect}/>
      </div>
    }
  }
}

export function mapStateToProps (state) {  
  return {
    veiculo: formValueSelector('formularioAlterarVeiculoItinerario')(state, 'veiculo'),
    empresaSelecionada: state.empresaSelecionada,
    itinerarioSelecionado: state.itinerarioSelecionado,
    tiposPreco: state.tiposPreco,
    veiculos: state.veiculos.veiculos,
    paginaAtual: state.paginaAtualItinerario,
    registrosPorPagina: state.registrosPorPaginaItinerario,
    rotaSelecionada: state.rotaSelecionada

  }
}


export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    changeFieldValue,
    cadastrarItinerario,    
    alterarItinerario,
    alterarVeiculoItinerario,
    ativarItinerario,
    inativarItinerario
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'formularioAlterarVeiculoItinerario',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(ModalAlterarVeiculoItinerario));
